import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "QR Code", -1)

import { computed } from 'vue'
import { useStore } from 'vuex'

import { EnterpriseSchema } from '@/generated/sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterprisePage',
  setup(__props) {

const store = useStore()

const enterprise = computed<EnterpriseSchema>(() => store.state.app.enterprise)

return (_ctx: any,_cache: any) => {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_QrCode = _resolveComponent("QrCode")!
  const _component_DodoCard = _resolveComponent("DodoCard")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(enterprise.value.enterpriseDisplayName) + " (" + _toDisplayString(enterprise.value.name) + ")", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DodoCard, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_QrCode)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})